import { type InteractionType } from '../types';

/**
 * Interactions that no longer exist but may still be stored on older
 * presentations. They are shown and run as their replacement instead.
 */
const legacyInteractionFallbacks: Partial<Record<string, InteractionType>> = {
  textTrack: 'Quick Questions',
};

export const resolveInteractionType = <T,>(interactionType: T): T =>
  (legacyInteractionFallbacks[interactionType as string] as T) ?? interactionType;

export const resolveLegacySlide = <T extends { type?: InteractionType }>(slide: T): T => {
  const resolved = slide?.type && legacyInteractionFallbacks[slide.type];
  return resolved ? { ...slide, type: resolved } : slide;
};
